import React from 'react';
import './TechnologyLogos.css';

const TechnologyLogos = ({ category, logos }) => {
  if (!logos || logos.length === 0) return null;

  return (
    <div className="technology-logos-section">
      <div className="technology-logos-grid">
        {logos.map((logo, index) => (
          <div key={index} className="technology-logo-item">
            <img 
              src={logo.src} 
              alt={logo.alt || logo.name}
              className="technology-logo-img"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechnologyLogos;

